/**
 * variant-selector.js — Product variant selection.
 * Handles color swatches, text swatches, hidden variant input,
 * out-of-stock handling, price display, and quantity controls.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var productForm = document.getElementById('product-form');
    if (!productForm) return;

    var variantInput = productForm.querySelector('input[name="id"]');
    var addBtn = productForm.querySelector('[name="add"]');
    var priceDisplay = document.querySelector('.product-info-price-row');
    var stockDisplay = document.querySelector('.product-info-stock');
    var skuDisplay = document.querySelector('.product-info-sku');
    var labelDisplays = document.querySelectorAll('[data-option-label]');
    var galleryMain = document.querySelector('[data-gallery-main]');
    var mainImage = galleryMain ? galleryMain.querySelector('img') : null;
    var galleryThumbs = document.querySelectorAll('[data-gallery-thumbs] .product-gallery-thumb');
    var selectedOptions = {};
    var productJSON = window.productJSON || null;
    var selectedVariant = null;

    if (!productJSON || !productJSON.variants) return;

    /* ---- helpers ---------------------------------------------------- */

    function safeFormatMoney(amount) {
      var RUPEES_FORMAT = 'Rs. {{amount_no_decimals_with_comma_separator}}';
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(amount, RUPEES_FORMAT);
      }
      // Fallback formatting (amount is in cents)
      if (amount === null || amount === undefined || isNaN(amount)) return '';
      var value = (amount / 100).toFixed(2);
      var parts = value.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return RUPEES_FORMAT
        .replace('{{amount_with_comma_separator}}', intPart)
        .replace('{{amount_with_apostrophe_separator}}', intPart.replace(/,/g, "'"))
        .replace('{{amount_no_decimals}}', intPart)
        .replace('{{amount_no_decimals_with_comma_separator}}', intPart)
        .replace('{{amount}}', intPart);
    }

    function updatePrice(variant) {
      if (!priceDisplay) return;
      if (!variant) return;
      var formatted;
      try {
        formatted = safeFormatMoney(variant.price);
      } catch (err) {
        return;
      }
      var html = '<span class="current">' + formatted + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<span class="original">' + safeFormatMoney(variant.compare_at_price) + '</span>';
      }
      priceDisplay.innerHTML = html;
    }

    function updateStock(variant) {
      if (!stockDisplay) return;
      if (variant.available) {
        stockDisplay.className = 'product-info-stock in-stock';
        stockDisplay.innerHTML = '<span class="stock-dot"></span> In Stock';
      } else {
        stockDisplay.className = 'product-info-stock out-of-stock';
        stockDisplay.innerHTML = '<span class="stock-dot"></span> Out of Stock';
      }
    }

    function updateAddButton(variant) {
      if (!addBtn) return;
      addBtn.disabled = !variant.available;
      if (variant.available) {
        addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Add to Cart';
      } else {
        addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Sold Out';
      }

      var bnb = productForm.querySelector('[data-action="buy-now"]');
      if (bnb) {
        bnb.disabled = !variant.available;
        if (variant.available) {
          bnb.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg> Buy Now';
        } else {
          bnb.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg> Sold Out';
        }
      }
    }

    function updateImage(variant) {
      if (!galleryMain || !mainImage) return;

      // Determine image to show for this variant
      // In Shopify's product JSON the variant image lives under 'featured_image'
      var image = null;
      if (variant) {
        if (variant.featured_image && variant.featured_image.id) {
          image = variant.featured_image;
        } else if (variant.image && variant.image.id) {
          image = variant.image;
        } else if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.id) {
          image = variant.featured_media.preview_image;
        }
      }
      if (!image && productJSON.images && productJSON.images.length) {
        image = productJSON.images[0];
      }
      if (!image || !image.id) return;

      // Find matching thumbnail to know the URL, fall back to product image list
      var imgSrc = null;
      var thumb = Array.prototype.slice.call(galleryThumbs).find(function (t) {
        return t.getAttribute('data-image-id') === String(image.id);
      });
      if (thumb) {
        imgSrc = thumb.getAttribute('data-image-src');
      } else if (productJSON.images) {
        var imgMeta = productJSON.images.find(function (i) { return i.id === image.id; });
        if (imgMeta) imgSrc = imgMeta.src;
      }
      if (!imgSrc) return;

      if (mainImage.getAttribute('src') === imgSrc) return;

      mainImage.style.opacity = '0';
      setTimeout(function () {
        mainImage.src = imgSrc;
        mainImage.setAttribute('data-image-id', String(image.id));
        mainImage.style.opacity = '1';
      }, 150);

      // Highlight the matching thumbnail
      galleryThumbs.forEach(function (t) {
        t.classList.remove('active');
      });
      if (thumb) thumb.classList.add('active');
    }

    function updateSKU(variant) {
      if (!skuDisplay) return;
      if (variant && variant.sku) {
        skuDisplay.textContent = 'SKU: ' + variant.sku;
        skuDisplay.style.display = '';
      } else {
        skuDisplay.style.display = 'none';
      }
    }

    function updateLabels() {
      labelDisplays.forEach(function(el) {
        var group = el.closest('.variant-option-group');
        if (!group) return;
        var swatch = group.querySelector('.variant-swatch.active');
        if (swatch) {
          el.textContent = swatch.getAttribute('data-option-value');
        }
      });
    }

    function tryMatchVariant() {
      var option1 = selectedOptions['option1'] || productJSON.variants[0].option1;
      var option2 = selectedOptions['option2'] || null;
      var option3 = selectedOptions['option3'] || null;

      var match = productJSON.variants.find(function (v) {
        return (
          v.option1 === option1 &&
          (!option2 || v.option2 === option2) &&
          (!option3 || v.option3 === option3)
        );
      });

      if (match) {
        selectedVariant = match;
        window.selectedVariantData = match;
        if (variantInput) variantInput.value = match.id;

        var guards = [
          function () { updatePrice(match); },
          function () { updateStock(match); },
          function () { updateAddButton(match); },
          function () { updateImage(match); },
          function () { updateSKU(match); }
        ];
        guards.forEach(function (fn) {
          try { fn(); } catch (e) { /* never block sibling updates */ }
        });
      }
    }

    /* ---- swatches --------------------------------------------------- */

    document.querySelectorAll('.variant-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.classList.contains('disabled')) return;

        var optionIndex = swatch.closest('.variant-swatches').getAttribute('data-option-index');
        var optionName = 'option' + (parseInt(optionIndex, 10) + 1);
        var value = swatch.getAttribute('data-option-value');

        // Deactivate siblings
        swatch.closest('.variant-swatches').querySelectorAll('.variant-swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');

        selectedOptions[optionName] = value;
        updateLabels();
        tryMatchVariant();
      });
    });

    /* ---- quantity controls ------------------------------------------- */

    var qtyInput = productForm.querySelector('[data-quantity-input]');
    if (qtyInput) {
      productForm.querySelector('[data-action="decrease-quantity"]').addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });

      productForm.querySelector('[data-action="increase-quantity"]').addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        qtyInput.value = val + 1;
      });
    }

    /* ---- buy now button ---------------------------------------------- */

    var buyNowBtn = productForm.querySelector('[data-action="buy-now"]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (buyNowBtn.disabled) return;

        var vid = variantInput ? parseInt(variantInput.value, 10) : 0;
        if (!vid || vid === 0) {
          alert('Please select a variant before buying.');
          return;
        }

        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        buyNowBtn.disabled = true;

        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: qty })
            });
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowBtn.disabled = false;
          });
      });
    }

    /* ---- validate before submit -------------------------------------- */

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (variantInput && (!variantInput.value || variantInput.value === '0')) {
        alert('Please select a variant before adding to cart.');
        return false;
      }

      // AJAX add-to-cart instead of page reload
      var variantId = parseInt(variantInput.value, 10);
      var qtyInput = productForm.querySelector('[data-quantity-input]');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (!variantId || !addBtn) return;
      if (addBtn.disabled) return;

      // Gather item data for optimistic UI
      var section = productForm.closest('.product-page, .product-section, section');
      var itemData = { image: '', title: '', price: '', quantity: quantity, url: window.location.href };
      if (section) {
        var mainImg = section.querySelector('.product-gallery-main img, .product-main-image img');
        if (mainImg) itemData.image = mainImg.src;
        var titleEl = section.querySelector('.product-title, .product-info-title, .product-info-name');
        if (titleEl) itemData.title = titleEl.textContent.trim();
        var priceEl = section.querySelector('.product-info-price-row .current, .product-price .current');
        if (priceEl) {
          itemData.price = priceEl.textContent.trim();
        }
      }

      var origHtml = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Adding...';

      if (window.kaqazCart && window.kaqazCart.add) {
        window.kaqazCart.add(variantId, quantity, itemData).then(function () {
          addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Added!';
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.innerHTML = origHtml;
          }, 1500);
          // Auto-open mini-cart on desktop
          var miniCart = document.getElementById('miniCart');
          if (miniCart && window.innerWidth > 768) {
            miniCart.style.display = 'block';
          }

          // Fly-to-cart animation
          var flyImg = mainImage ? mainImage.src : (itemData.image || '');
          var rect = addBtn.getBoundingClientRect();
          var startX = rect.left + rect.width / 2;
          var startY = rect.top;
          document.dispatchEvent(new CustomEvent('kaqaz:fly-to-cart', {
            detail: { x: startX, y: startY, image: flyImg }
          }));
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = origHtml;
        });
      }
    });

    // Initial state
    tryMatchVariant();

  });
})();
